import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";

import { AlertService, EmployeeService } from "../../_services";
import { Utils } from "../../_helpers";

@Component({ templateUrl: "employee.add.html" })
export class EmployeeAdd implements OnInit {
  heading = "Add Employee";
  subheading = "";
  icon = "fa fa-users icon-gradient bg-happy-itmeo";
  employeeForm: FormGroup;
  loading = false;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private employeeService: EmployeeService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.employeeForm = this.formBuilder.group({
      employee_name: ["", [Validators.required, Utils.noWhitespaceValidator]],
      employee_id: ["", [Validators.required, Utils.noWhitespaceValidator]]
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.employeeForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.employeeForm.invalid) {
      return;
    }

    this.loading = true;

    const formData = new FormData();
    formData.append("employee_name", this.employeeForm.get("employee_name").value);
    formData.append("employee_id", this.employeeForm.get("employee_id").value);

    this.employeeService
      .insert(formData)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data.status == "ok") {
            this.alertService.success(data.message, true);
            this.router.navigate(["/employees"]);
          } else {
            this.alertService.error(data.message, true);
            this.loading = false;
          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        }
      );
  }
}
